// extracted by mini-css-extract-plugin
export default {"root":"diagramTechState_root__YeGV8","diagram":"diagramTechState_diagram__RLMdk","label":"diagramTechState_label__j61oq"};